import { BaseService, Body, ExtraMap, GET, Header, POST, PUT, Query, Signal } from 'ts-retrofit3';

import { AUTH_API } from '@/Module/Auth/Constant';
import type { IAuthLinkRubikaUserQuery, IAuthPersonUpdateBody } from '@/Module/Auth/Model/ApiModel';
import type {
  ICategoryCategory,
  ICity,
  IPerson,
  IProvince,
  IReferTypePerson,
  IReferTypes,
  IStatistics,
} from '@/Module/Auth/Model/DataModel';
import type { IExtra, IResponse } from '@/Module/Core/Model/ApiModel';
import { HttpService } from '@/Module/Core/Service';
import type { IExamAuth } from '@/Module/Exam/Model/ApiModel';

class AuthService extends BaseService {
  @GET(AUTH_API.GET_STATES)
  async getStates(@Signal _signal?: AbortSignal): Promise<IResponse<IProvince[]>> {
    return <IResponse>{};
  }

  @GET(AUTH_API.GET_STATISTICS)
  async getStatistics(@Signal _signal?: AbortSignal): Promise<IResponse<IStatistics>> {
    return <IResponse>{};
  }

  @GET(AUTH_API.GET_REFER_TYPES)
  async getReferTypes(@Signal _signal?: AbortSignal): Promise<IResponse<IReferTypes[]>> {
    return <IResponse>{};
  }

  @GET(AUTH_API.GET_CITIES)
  async getCities(@Query('StateId') _query: IProvince['id'], @Signal _signal?: AbortSignal): Promise<IResponse<ICity[]>> {
    return <IResponse>{};
  }

  @GET(AUTH_API.GET_CATEGORY_BY_GRADE_ID)
  async getCategoryByGradeId(
    @Query('id') _query: IPerson['gradeId'],
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<ICategoryCategory[]>> {
    return <IResponse>{};
  }

  @GET(AUTH_API.GET_MY_PERSON)
  async getMyPerson(
    @Header('serverAuthorization') _authorization?: string,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<IPerson>> {
    return <IResponse>{};
  }

  @PUT(AUTH_API.UPDATE_MY_PERSON)
  async updatePerson(@Body _body: IAuthPersonUpdateBody, @Signal _signal?: AbortSignal): Promise<IResponse<IPerson>> {
    return <IResponse>{};
  }

  @PUT(AUTH_API.PUT_REFER_TYPE)
  async putReferType(
    @Header('serverAuthorization') _authorization: string,
    @Body _body: IReferTypePerson,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<IPerson>> {
    return <IResponse>{};
  }

  @POST(AUTH_API.POST_FREE_TRIAL)
  async postFreeTrial(
    @Header('serverAuthorization') _authorization: string,
    @ExtraMap _extra: IExtra,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse> {
    return <IResponse>{};
  }

  @PUT(AUTH_API.RUBIKA)
  async linkRubikaUser(
    @Header('serverAuthorization') _authorization: string,
    @Body _body: IAuthLinkRubikaUserQuery,
    @ExtraMap _extra: IExtra,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse> {
    return <IResponse>{};
  }

  @GET(AUTH_API.EXAM_REGISTER_OR_LOGIN)
  async getExamToken(
    @Header('SecurityToken') _authorization: string,
    @ExtraMap _extra: IExtra,
  ): Promise<IResponse<IExamAuth>> {
    return <IResponse>{};
  }
}

export default HttpService.build(AuthService);
